import React, { useContext } from "react";
import { FaHeart, FaRegHeart, FaBalanceScale } from "react-icons/fa";
import { MyContext } from "../Context/MyContext";
import { useToast } from "./Toast/ToastProvider";
import "./CarActionButtons.css";

export default function CarActionButtons({ car, variant = "card" }) {
  const {
    compare_page,
    isInWishlist,
    isInCompare,
    toggleWishlist,
    toggleCompare,
  } = useContext(MyContext);
  const { showToast } = useToast();

  const labels =
    variant === "detail"
      ? compare_page.detailActions || {}
      : compare_page.cardActions || {};
  const toast = compare_page.toast || {};

  const saved = isInWishlist(car.id);
  const compared = isInCompare(car.id);

  const handleWishlist = async (e) => {
    e.stopPropagation();
    const result = await toggleWishlist(car.id);
    if (result?.error) return;
    showToast({
      type: "success",
      title: saved ? toast.removedFromWishlist : toast.addedToWishlist,
    });
  };

  const handleCompare = (e) => {
    e.stopPropagation();
    const result = toggleCompare(car.id);
    if (result?.full) {
      showToast({
        type: "warning",
        title: "Compare list full",
        message: toast.compareFull?.replace("{max}", compare_page.maxCars),
      });
      return;
    }
    showToast({
      type: "success",
      title: compared ? toast.removedFromCompare : toast.addedToCompare,
    });
  };

  return (
    <div className={`car-action-buttons ${variant}`}>
      <button
        type="button"
        className={`action-btn wishlist ${saved ? "active" : ""}`}
        onClick={handleWishlist}
        title={saved ? labels.wishlistRemove : labels.wishlistAdd}
        aria-label={saved ? labels.wishlistRemove : labels.wishlistAdd}
      >
        {saved ? <FaHeart /> : <FaRegHeart />}
        {variant === "detail" && (
          <span>{saved ? labels.wishlistRemove : labels.wishlistAdd}</span>
        )}
      </button>
      <button
        type="button"
        className={`action-btn compare ${compared ? "active" : ""}`}
        onClick={handleCompare}
        title={compared ? labels.compareRemove : labels.compareAdd}
        aria-label={compared ? labels.compareRemove : labels.compareAdd}
      >
        <FaBalanceScale />
        {variant === "detail" && (
          <span>{compared ? labels.compareRemove : labels.compareAdd}</span>
        )}
      </button>
    </div>
  );
}
